import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { PrimeNgImportsModule } from "@toolkit";

import { ShellRoutingModule } from "./shell-routing.module";
import { ShellLayoutComponent } from "./layout/layout.component";
import { WelcomeComponent } from "./welcome/welcome.component";
import { FormsModule } from "@angular/forms";

@NgModule({
    imports: [
        PrimeNgImportsModule,
        CommonModule,
        FormsModule,
        RouterModule,
        ShellRoutingModule
    ],
    declarations: [
        ShellLayoutComponent,
        WelcomeComponent
    ]
})
export class ShellModule { }
